import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { ObserveProperty } from "@calaosoft/osapp-common/observable/decorators/observe-property.decorator";
import { ObservableProperty } from "@calaosoft/osapp-common/observable/models/observable-property";
import { secure } from "@calaosoft/osapp-common/rxjs/operators/secure";
import { ArrayHelper } from "@calaosoft/osapp-common/utils/helpers/arrayHelper";
import { tap } from "rxjs";
import { UiMessageService } from "../../../../services/uiMessage.service";
import { DestroyableComponentBase } from "../../../utils/components/destroyable-component-base";
import { IToast } from "../../models/itoast";
import { IToastResponse } from "../../models/itoast-response";

@Component({
	selector: "calao-toasts-wrapper",
	templateUrl: "./toasts-wrapper.component.html",
	styleUrls: ["./toasts-wrapper.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ToastsWrapperComponent extends DestroyableComponentBase implements OnInit {
	//#region PROPERTIES

	/** Tableau des toasts à afficher dans le wrapper. */
	@Input() public toasts?: IToast[];
	@ObserveProperty<ToastsWrapperComponent>({ sourcePropertyKey: "toasts" })
	public readonly obsToasts = new ObservableProperty<IToast[]>();

	//#endregion PROPERTIES

	//#region METHODS

	constructor(private readonly isvcUiMessage: UiMessageService) {
		super();
	}

	public ngOnInit(): void {
		this.isvcUiMessage.toasts$
			.pipe(
				tap((paToasts: IToast[]) => (this.obsToasts.value = paToasts)),
				secure(this)
			)
			.subscribe();
	}

	public onDismissToast(psToastId: string): void {
		this.removeToastFromActiveToasts(psToastId);
	}

	public onResponse(poToastResponse: IToastResponse<any>): void {
		this.isvcUiMessage.raiseToastResponse(poToastResponse);
	}

	private removeToastFromActiveToasts(psToastId: string) {
		let laActiveToasts: IToast[] = [];

		if (ArrayHelper.hasElements(this.obsToasts.value))
			laActiveToasts = this.obsToasts.value.filter((poToast: IToast) => poToast.id !== psToastId);

		this.isvcUiMessage.raiseToasts(ArrayHelper.appendArrays([], laActiveToasts));
	}

	//#endregion METHODS
}
